import React, { Component } from "react";
import AntdCol, {ColProps} from 'antd/lib/col';
import 'antd/lib/col/style';

export default class Col extends Component<ColProps> {
    render() {
        return (
          <AntdCol {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/col/index.tsx